// @flow

// Vendors
import React from 'react';

// types
import { InputType } from '../../../types';
type InputToggleType = InputType & {
  toggleLabelOn: string,
  toggleLabelOff: string
};

const InputToggle = ({
  label,
  toggleLabelOn,
  toggleLabelOff,
  type,
  ...props
}: InputToggleType) => (
  <>
    <label className="form__label">{label}</label>
    <div className="toggle">
      <input type="checkbox" className="toggle__checkbox" {...props} />
      <label
        htmlFor={props.id}
        className="toggle__label"
        data-label-on={toggleLabelOn}
        data-label-off={toggleLabelOff}
      >
        <div
          className="toggle__label__indicator"
          data-label-on={toggleLabelOn}
          data-label-off={toggleLabelOff}
        />
      </label>
    </div>
  </>
);

export default InputToggle;
